// Per-column text-wrap preference for the workflows table, persisted to
// tenancy_solution_versions_ps.columnWrapSettings (jsonb). Keyed by column id
// so the model matches columnPinningSettings; PSTUDIO-2870 only surfaces the
// Message column in the UI (other columns are a separate ticket), but the
// shape is already column-generic.
export type ColumnWrapSettings = Partial<Record<string, boolean>>;

export const defaultColumnWrapSettings: ColumnWrapSettings = {};

/** Normalize a raw jsonb blob from the backend into a clean boolean map. */
export function resolveColumnWrapSettings(data: unknown): ColumnWrapSettings {
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    // Arrays are `typeof === 'object'`; reject them (and null/primitives) so a
    // malformed blob can never surface as { "0": true, ... } index-keyed junk.
    return { ...defaultColumnWrapSettings };
  }
  const out: ColumnWrapSettings = {};
  for (const [key, value] of Object.entries(data as Record<string, unknown>)) {
    if (typeof value === 'boolean') out[key] = value;
  }
  return out;
}

export function isColumnWrapEnabled(
  settings: ColumnWrapSettings,
  columnId: string
): boolean {
  return settings[columnId] === true;
}

/** Immutable toggle — never mutates the input map. */
export function toggleColumnWrap(
  settings: ColumnWrapSettings,
  columnId: string,
  enabled: boolean
): ColumnWrapSettings {
  return { ...settings, [columnId]: enabled };
}
